import { render, staticRenderFns } from "./lemonCustomer.vue?vue&type=template&id=45e2ff26&"
import script from "./lemonCustomer.vue?vue&type=script&lang=js&"
export * from "./lemonCustomer.vue?vue&type=script&lang=js&"
import style0 from "./lemonCustomer.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports